import * as React from 'react';
import { IActivityDataUploadConnectProps } from './activity-data-upload-container';
import { BasicDataUploadContainer } from '../../data-upload/basic-data-upload';
import { IAppActivityConfig } from '../../../interfaces';
import { DataLoadApi, IActivityConfigOptions, IUploadBasicFileOptions } from '../../../api';
import { getAppActivityConfig } from '../../../functions';
import * as Actions from '../../../actions';

export class ActivityDataUpload extends React.Component<IActivityDataUploadConnectProps> {
  constructor(props: IActivityDataUploadConnectProps) {
    super(props);
    this.uploadFile = this.uploadFile.bind(this);
  }

  public uploadFile(): Promise<{}> {
    const options: IUploadBasicFileOptions = {
      dataFile: this.props.upload.dataFile,
      sheetIndex: this.props.upload.sheetIndex,
      startRow: this.props.upload.dataStartRow,
      endRow: this.props.upload.dataEndRow
    };

    return DataLoadApi.uploadActivityFile(options).request()
      .then((response: IActivityConfigOptions): {} => {
        const config: IAppActivityConfig = getAppActivityConfig(response.config);

        this.props.dispatch(Actions.Config.setColumns(response.columns));
        this.props.dispatch(Actions.Config.setActivityConfig(config));
        return {};
      });
  }

  public render(): JSX.Element {
    return <BasicDataUploadContainer uploadFile={this.uploadFile} />;
  }
}
